import { keepPreviousData } from '@tanstack/react-query';
import { TableState } from '@optimus-web/core';
import { RateOverview, RateOverviewFilters, useRepositoryQuery } from '@mews-commander/data-access';
import { useCurrentServiceIdContext } from '../contexts';

export const useGetRateOverview = (
    tableState: TableState<RateOverview, RateOverviewFilters>,
    rateFilters?: RateOverviewFilters
) => {
    const serviceId = useCurrentServiceIdContext();

    return useRepositoryQuery(
        'rates',
        'getOverviewEntries',
        {
            serviceId,
            ...tableState,
            filters: rateFilters,
        },
        {
            staleTime: 5000,
            placeholderData: keepPreviousData,
        }
    );
};
